import React, { useContext, useRef } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import LocaleContext from '../../contexts/localeContext'
import { useCountriesForFormsDictionary } from '../../hooks/useCountriesForFormsDictionary'
import { useCountries } from '../../hooks/useCountries'
import { useRequestQuoteI18n } from '../../hooks/i18n/useRequestAQuoteI18n'
import GeolocationContext from '../../contexts/geolocationContext'
import { useState } from 'react'
import { useEffect } from 'react'
import TextInput from '../formInputs/textInput'
import SelectInput from '../formInputs/selectInput'
import { getI18nText } from '../../services/i18nService'
import { submitFormToSalesForce } from '../../services/backendApiService'
import { useFormI18n } from '../../hooks/i18n/useFormI18n'
import { ColouredSubmitButton } from '../widgets/standardSubmitButton'
import { v4 as uuid } from 'uuid'
import FormDataLayer from '../widgets/formDataLayer'

const ProductRequestAQuoteModal = ({ isOpen, closeModal, productCode }) => {
  const submitUrl = 'l/1070292/2024-07-24/958vfp'
  const methods = useForm()
  const locale = useContext(LocaleContext)
  const submitRef = useRef(null)
  const countriesDictionary = useCountriesForFormsDictionary(locale)
  const countries = useCountries(locale)
  const microcopy = useRequestQuoteI18n(locale)
  const { country } = useContext(GeolocationContext)
  const [selectedCountry, setSelectedCountry] = useState()
  const [isFormValidated, setIsFormValidated] = useState(false)
  const [formSubmitSuccess, setFormSubmitSuccess] = useState(false)
  const [formSubmitFailed, setFormSubmitFailed] = useState(false)
  const formMicrocopy = useFormI18n(locale)

  useEffect(() => {
    if (country) {
      setSelectedCountry(country === 'GB' ? 'UK' : country)
    } else {
      setSelectedCountry(countriesDictionary[0].key)
    }
  }, [country])

  function onSubmit(data) {
    setIsFormValidated(true)
    data.requestaquote.item = productCode

    var json = JSON.stringify(data['requestaquote'])
    var requestId = uuid()

    submitFormToSalesForce(json, submitUrl, requestId)
      .then((data) => {
        setFormSubmitSuccess(true)
        setFormSubmitFailed(false)
        methods.reset()
      })
      .catch((data) => {
        setFormSubmitSuccess(false)
        setFormSubmitFailed(true)
      })
  }

  return (
    <>
      <div className="modal-body modal__text--body">
        <div className="modal__text--container">
          {formSubmitSuccess || formSubmitFailed ? (
            <>
              {formSubmitSuccess ? (
                <>{getI18nText(microcopy, 'requestaquote.quotesentsuccessfully')}</>
              ) : (
                <>{getI18nText(microcopy, 'requestaquote.errorwhensendingquote')}</>
              )}
            </>
          ) : (
            <FormProvider {...methods}>
              <form onSubmit={methods.handleSubmit(onSubmit)} className="m-0" noValidate>
                <FormDataLayer
                  formName='ProductRequestAQuote'
                  formId={submitUrl}
                  submitRef={submitRef}
                />
                <div className="needs-validation">
                  <div className="registration__item shipping__tabs--container mb-0">
                    <div className="form">
                      <div className="form__fields d-flex flex-wrap justify-content-between">
                        <TextInput
                          inputName="requestaquote.first_name"
                          microcopyName={'requestaquote.firstname'}
                          microcopy={microcopy}
                          required={true}
                        />
                        <TextInput
                          inputName="requestaquote.last_name"
                          microcopyName={'requestaquote.lastname'}
                          microcopy={microcopy}
                          required={true}
                        />
                        <TextInput
                          inputName="requestaquote.company_name"
                          microcopyName={'requestaquote.company'}
                          microcopy={microcopy}
                          required={true}
                        />
                        <SelectInput
                          inputName="requestaquote.country"
                          required={true}
                          microcopyName={'requestaquote.country'}
                          microcopy={microcopy}
                          options={countriesDictionary}
                          selectedOptionKey={selectedCountry}
                        />
                        <TextInput
                          inputName="requestaquote.email"
                          microcopyName={'requestaquote.email'}
                          microcopy={microcopy}
                          required={true}
                        />
                        <TextInput
                          inputName="requestaquote.phone"
                          required={true}
                          microcopyName={'requestaquote.telephone'}
                          microcopy={microcopy}
                          pattern={/^.{1,20}$/}
                          patternErrorMessage={getI18nText(
                            formMicrocopy,
                            'form.incorrecttelephoneformat'
                          )}
                        />                        
                        <TextInput
                          inputName="requestaquote.comments"
                          required={false}
                          microcopyName={'requestaquote.comments'}
                          microcopy={microcopy}
                        />
                        <ColouredSubmitButton
                          value={getI18nText(microcopy, 'requestaquote.sendrequest')}
                          colour="red"
                          refCallback={submitRef}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </FormProvider>
          )}
        </div>
      </div>
    </>
  )
}

export default ProductRequestAQuoteModal
